import React, { useEffect, useState } from 'react';
import { Link as LinkS } from 'react-scroll';
import './Nav.css';
import { AiOutlineHome, AiOutlineUser, AiOutlineBook } from 'react-icons/ai';
import { FaRegImages } from "react-icons/fa6";
import { RiServiceLine } from 'react-icons/ri';
import { BiMessageDots } from 'react-icons/bi';

const useScrollSpy = (sectionIds, offset = 0) => {
    const [activeSection, setActiveSection] = useState(null);

    useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.scrollY + window.innerHeight / 2;

            for (const id of sectionIds) {
                const element = document.querySelector(id);
                if (element && element.offsetTop <= scrollPosition && element.offsetTop + element.offsetHeight > scrollPosition) {
                    setActiveSection(id);
                    break;
                }
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [sectionIds, offset]);

    return activeSection;
};

const Nav = () => {
    const sectionIds = ['#Header', '#about__me', '#experiense', '#services', '#Galleryy', '#contact'];
    const activeNav = useScrollSpy(sectionIds);

    const [showNav, setShowNav] = useState(true);

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollTop = window.scrollY;
            const viewportHeight = window.innerHeight;

            if (currentScrollTop < viewportHeight * 0.5) {
                // In the first 50vh of the page
                setShowNav(false);
            } else {
                // Past the initial 50vh
                setShowNav(true);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <nav className={showNav ? 'showNav' : 'hideNav'}>
            <LinkS to="Header" className={activeNav === '#Header' ? 'active' : ''} smooth={true} duration={1500}><AiOutlineHome /></LinkS>
            <LinkS to="about__me" className={activeNav === '#about__me' ? 'active' : ''} smooth={true} duration={1500}><AiOutlineUser /></LinkS>
            <LinkS to="experiense" className={activeNav === '#experiense' ? 'active' : ''} smooth={true} duration={1500}><AiOutlineBook /></LinkS>
            <LinkS to="services" className={activeNav === '#services' ? 'active' : ''} smooth={true} duration={1500}><RiServiceLine /></LinkS>
            <LinkS to="Galleryy" className={activeNav === '#Galleryy' ? 'active' : ''} smooth={true} duration={1500}><FaRegImages /></LinkS>
            <LinkS to="contact" className={activeNav === '#contact' ? 'active' : ''} smooth={true} duration={1500}><BiMessageDots /></LinkS>
        </nav>
    );
};

export default Nav;
